//TODO: Currently designs not finalized for this, so we are not using this component in the project, remove or use post design finalization
import { theme } from "@tm/utility/global";
import styled, { css, keyframes } from "styled-components";

const shake = keyframes`
  0%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-4px);
  }
  75% {
    transform: translateX(4px);
  }
`;

export const TravellerInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const TravellerInputContainer = styled.div<{ hasError?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 12px;
  border: 1px solid ${({ hasError }) => (hasError ? "#E53E3E" : "#E0E0E0")};
  background: ${theme.whiteText};
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  ${({ hasError }) =>
    hasError &&
    css`
      animation: ${shake} 0.3s ease-in-out;
    `}
`;

export const CounterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const ButtonStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const CountButton = styled.button<{ disabled?: boolean }>`
  width: 24px;
  height: 18px;
  border-radius: 4px;
  border: 1px solid ${({ disabled }) => (disabled ? "#E0E0E0" : theme.blueText)};
  background: ${({ disabled }) => (disabled ? "#F5F5F5" : theme.blueText)};
  color: ${({ disabled }) => (disabled ? "#BDBDBD" : theme.whiteText)};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  transition: all 0.15s ease;
  flex-shrink: 0;
  user-select: none;
  padding: 0;

  &:hover:not(:disabled) {
    background: ${({ disabled }) => (disabled ? "#F5F5F5" : "#0077DD")};
  }

  &:active:not(:disabled) {
    transform: scale(0.95);
  }

  ${({ disabled }) =>
    !disabled &&
    css`
      &:focus {
        outline: none;
        box-shadow: 0 0 0 2px rgba(0, 140, 255, 0.2);
      }
    `}
`;

export const NumberInput = styled.input<{ hasError?: boolean }>`
  width: 75px;
  height: 36px;
  border: none;
  background: transparent;
  text-align: center;
  font-family: Lato, sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: ${({ hasError }) => (hasError ? "#E53E3E" : theme.blackText)};
  outline: none;
  padding: 0;
  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &::placeholder {
    color: ${theme.greyText4};
    font-weight: 400;
  }

  &:focus {
    outline: none;
  }
`;

export const TravellerLabel = styled.span`
  font-family: Lato, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  color: ${theme.greyText};
  white-space: nowrap;
`;

export const ErrorMessage = styled.span`
  position: absolute;
  top: 100%;
  left: 0;
  color: #e53e3e;
  font-size: 12px;
  font-weight: 500;
  font-family: Lato, sans-serif;
  display: flex;
  align-items: center;
  gap: 4px;
  padding-top: 4px;
  white-space: nowrap;
`;

export const LabelText = styled.span`
  font-family: Lato, sans-serif;
  font-weight: 900;
  font-size: 14px;
  color: ${theme.greyText};
  margin-bottom: 2px;
`;

export const InputSection = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

export const SubTitle = styled.span`
  font-family: Lato, sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: ${theme.greyText6};
  text-align: center;
  padding-top: 4px;
  border-top: 1px solid #f0f0f0;
`;
